import SalonBusinessCpaTopicWorkspace from "./SalonBusinessCpaTopicWorkspace";

export default function SalonBusinessCpaIncomeTaxes() {
  return <SalonBusinessCpaTopicWorkspace topicKey="income_taxes" />;
}
